import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { ManagerState, Manager, IBusiness } from './managerTypes';
import { IRouterProps } from '@/router/interfaces/router-props.interface';
import { RootState } from '../types';
import jwtDecode from 'jwt-decode';
import APIService from '@/api';
import AdminService from '@/api/AdminService';
import Module from '../interfaces/module.interface';

const service = new APIService();

export const state: ManagerState = new ManagerState({}, []);

const factory = async (context: IRouterProps) => {
  if (context.auth === 'manager') {
    context.store.dispatch(
      'manager/SET_MANAGER',
      jwtDecode(service.getCredentials())
    );
  }
};

const actions: ActionTree<ManagerState, RootState> = {
  SET_MANAGER(context, payload: ManagerState) {
    context.commit('setManager', payload);
  },
  SET_BUSINESS_LIST(context, payload: IBusiness[]) {
    context.commit('setBusinessList', payload);
  }
};

const mutations: MutationTree<ManagerState> = {
  setManager(state, payload: Manager) {
    state.info = payload;
  },
  setBusinessList(state, payload: IBusiness[]) {
    state.business = payload;
  }
};

const getters: GetterTree<ManagerState, RootState> = {
  getRequireBusiness(state) {
    return state.info.extraInfo ? state.info.extraInfo.requireBusiness : null;
  },
  getRole(state) {
    return state.info.extraInfo ? state.info.extraInfo.role : null;
  },
  getExtraInfo(state) {
    return state.info.extraInfo;
  },
  isImpersonated() {
    const adminService = new AdminService();
    const adminCredentials = adminService.getCredentials(true);

    if (adminCredentials) {
      const { extraInfo } = jwtDecode(adminCredentials);
      return extraInfo && extraInfo.isImpersonated;
    }

    return false;
  },
  hasTwismWalletAccess() {
    const adminService = new AdminService();
    const adminCredentials = adminService.getCredentials(true);

    if (adminCredentials) {
      const { extraInfo } = jwtDecode(adminCredentials);

      return extraInfo && extraInfo.hasTwismWalletAccess;
    }

    return false;
  },
  getPermissions() {
    const adminService = new AdminService();
    const adminCredentials = adminService.getCredentials(true);

    if (adminCredentials) {
      const { extraInfo } = jwtDecode(adminCredentials);

      return (extraInfo && extraInfo.permissions) || [];
    }

    return [];
  },
  getBusinessList(state) {
    return state.business;
  }
};

const namespaced: boolean = true;

export const manager: Module<ManagerState, RootState> = {
  namespaced,
  initializer: {
    factory,
    on: 'BeforeEachRoute',
    provide: 'ManagerStore'
  },
  state,
  actions,
  mutations,
  getters
};
